function printTable(headers, formatedData) {
  // Open the print window
  const WinPrint = window.open(
    '',
    '',
    'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0'
  );

  let tableHeader = '';
  headers.forEach(item => (tableHeader += `<th>${item}</th>`));

  let tableContent = '';
  formatedData.forEach(row => {
    let columns = '';
    for (const col in row) {
      columns += `<td>${row[col]}</td>`;
    }
    tableContent += `<tr>${columns}</tr>`;
  });

  // Make Table
  WinPrint.document.write(`<!DOCTYPE html>
  <html>
    <head>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.2.9/semantic.min.css"/>
    </head>
    <body>
      <table class="ui celled striped table printable">
        <thead>
          <tr>
            ${tableHeader}
          </tr>
        </thead>
        <tbody>
          ${tableContent}
        </tbody>
      </table>
      <script
  src="https://code.jquery.com/jquery-3.1.1.min.js"
  integrity="sha256-hVVnYaiADRTO2PzUGmuLJr8BLUSjGIZsDYGmIJLv2b8="
  crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.4.1/semantic.min.js"></script>
    </body>
  </html>`);

  WinPrint.document.close();
  WinPrint.focus();
  WinPrint.print();
  WinPrint.close();
}

export default printTable;
